var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "desktop-feature-medical-gradient",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF500B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#desktop-feature-medical-gradient)",
    d: "M21.0827 9.3959V20.6251A.4583.4583 0 0 1 20.6243 21.0834H18.791a.4583.4583 0 0 1-.4583-.4583V8.7084a.4583.4583 0 0 1 .4583-.4583h1.1458c.6325.0007 1.1451.5133 1.1459 1.1458ZM4.1243 4.5834H2.0618c-.6325.0007-1.1451.5133-1.1458 1.1458v14.8959c0 .2531.2052.4583.4583.4583h2.75c.2531 0 .4583-.2052.4583-.4583V5.0417c0-.2531-.2052-.4583-.4583-.4583ZM16.2702.9167H6.6452c-.6325.0008-1.1451.5133-1.1458 1.1458v18.5626c0 .2531.2052.4583.4583.4583h3.6667c.2531 0 .4583-.2052.4583-.4583v-5.2708c.0004-.3795.308-.6871.6875-.6875h1.375c.3795.0004.6871.308.6875.6875v5.2708c0 .2531.2052.4583.4583.4583h3.6667c.2531 0 .4583-.2052.4583-.4583V2.0626c-.0007-.6325-.5133-1.1451-1.1458-1.1459Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.07f81a644f9dc565cbe989dfc5cee064.svg";
export { ForwardRef as ReactComponent };